module.exports = __webpack_public_path__ + "static/img/mo_btn1.5a0a2c0.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/home/pc/role3/control/mo_btn1.png
// module id = wQT4
// module chunks = 7